import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "default-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = { class: "file-label" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "input-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Update Estate Map")
    ], -1)),
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Width", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.width.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.width) = $event)),
            type: "number",
            placeholder: "Width"
          }, null, 2), [
            [_vModelText, $setup.form.width]
          ]),
          ($setup.v$.width.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.width.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label" }, "Height", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.height.$error }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.height) = $event)),
            type: "number",
            placeholder: "Height"
          }, null, 2), [
            [_vModelText, $setup.form.height]
          ]),
          ($setup.v$.height.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.height.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Current Map", -1)),
          ($setup.map)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $setup.map.mapImage.url
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, [
            _cache[7] || (_cache[7] = _createTextVNode("Choose New File", -1)),
            _createElementVNode("input", {
              onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.selectFile($event))),
              type: "file",
              accept: "image/png"
            }, null, 32),
            ($setup.form.file)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.form.file.name), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "button default outlined cancel-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.go(-1))),
          type: "button"
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button default primary create-btn",
          onClick: $setup.updateMap,
          type: "button"
        }, "Update")
      ])
    ])
  ], 64))
}